import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LoginRequired } from "../../../decorators/login.required";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { AuthService } from "../../../services/auth.service";
import { ApiService } from "../../../services/api.service";
import { IonicHelper } from "../../../helpers/ionic.helper";
import { UserService } from "../../../services/user.service";
import { User, UserGroup } from "../../../app/app.interfaces";
import { FormValidators } from "../../../form/form.validators";
import { UserGroupService } from "../../../services/user-group.service";
import { ObjectifyPipe } from "../../../pipes/objectify";
import { FormGroupControls, FormHelper } from "../../../helpers/form.helper";
import { UploadedFile } from "../../../app/app.models";

@Component({
	selector: 'profile-form',
	templateUrl: 'profile-form.html'
})

export class ProfileForm implements OnInit {

	form: FormGroup;
	showErrors: boolean = false;
	@Input() user: User;
	loginRequired: boolean = true;
	ownProfile: boolean = false;
	@Output() editDone: EventEmitter<User> = new EventEmitter<User>();


	constructor(private formBuilder: FormBuilder,
							public authService: AuthService,
							private apiService: ApiService,
							private ionic: IonicHelper,
							private userService: UserService,
							public userGroupService: UserGroupService,
              private changeDetector: ChangeDetectorRef) {
	}


	ngOnInit(): void {
		if(this.user){

			if(this.user === this.authService.user){
				this.ownProfile = true;
			}

			this.buildProfileForm().then((form) => {
				this.form = form;

			},(err) => {
				console.error(err);
			});
		}


	}
	
	
	buildProfileForm(): Promise<FormGroup> {

		return new Promise<FormGroup>((resolve) => {

			let passwordGroup = this.formBuilder.group({
				password: ['', Validators.compose([Validators.minLength(6), Validators.maxLength(60)])],
				confirmPassword: ['']
			}, {
				validator: FormValidators.matchFields
			});
			
			let avatarFile: UploadedFile = new UploadedFile(this.user.avatar, this.user.avatar, '', 'image');

			let form = this.formBuilder.group({
				firstName: [this.user.firstName, Validators.compose([Validators.minLength(3), Validators.maxLength(100)])],
				lastName: [this.user.lastName, Validators.compose([Validators.minLength(3), Validators.maxLength(100)])],
				description: [this.user.description, Validators.compose([Validators.minLength(10), Validators.maxLength(250)])],
				passwords: passwordGroup,
				avatar: avatarFile

			});
			
			if (this.authService.user.admin) {

				form.addControl('userGroup', new FormControl(this.user.userGroup));

				if(!this.ownProfile)	form.addControl('admin', new FormControl(this.user.admin));

				resolve(form);

			}
			else{
				resolve(form);
			}

		});
	}




	submitForm(origin: string = 'submit'): void {
		
		this.ionic.toggleLoader(true);

		if(this.checkValidityOfSelectedForms()){

			let newUserData = {};
			for (let key in this.form.controls) {
				if(! this.form.controls[key].pristine){
					if(key==='passwords'){
						newUserData['plainPassword'] = this.form.value[key]['password'];
					}
					else if (key==='avatar'){
					  newUserData[key] = this.form.value[key].fileName;
          }
					else {
						newUserData[key] = this.form.value[key];
					}
				}
			}

			this.apiService.updateResource(this.user, newUserData).then((updatedUser: User) => {

				this.user = updatedUser;
				this.form.controls['passwords'].reset();
				this.form.markAsPristine();

				if(this.authService.user.admin && updatedUser.id != this.authService.user.id){
					this.ionic.toggleLoader(false);
					this.ionic.toast((origin === 'avatarUpload') ? 'PROFILE.UPDATED_OTHER_AVATAR':'PROFILE.UPDATED_OTHER');
					this.editDone.emit(updatedUser);
				}
				else{
					this.userService.reloadAuthenticatedUser(updatedUser).then(()=> {
						this.ionic.toggleLoader(false);
					  this.ionic.toast((origin === 'avatarUpload') ? 'PROFILE.UPDATED_AVATAR':'PROFILE.UPDATED');
						this.editDone.emit(updatedUser);
					});
				}

			}).catch((err)=>{
    		console.error(err);    	
				this.ionic.toggleLoader(false);
      	this.ionic.alert('GLOBAL.GENERAL_ERROR');
			});


		}
		else{
			this.ionic.toggleLoader(false);
		}
	}
	
	avatarUploaded(){
		this.submitForm('avatarUpload');
	}

	checkValidityOfSelectedForms(): boolean{
		let invalidFormControls: FormGroupControls = {};


		let allFilledFieldsValid: boolean = true;

		for (let key in this.form.controls) {
			if(!this.form.controls[key].pristine && !this.form.controls[key].valid){
				invalidFormControls[key] = this.form.controls[key];
				allFilledFieldsValid = false;
			}
		}

		if(!allFilledFieldsValid){
			this.ionic.toggleLoader(false);
			this.ionic.invalidFieldsAlert(
				'SETTINGS.ERROR',
				'SETTINGS.TRY_AGAIN',
				'ACCEPT_INVITE.ERRORS',
				FormHelper.getInvalidFormControls(invalidFormControls)
			);
		}

		return allFilledFieldsValid;


	}



	setUserEnabled(enabled: boolean) {

		if(!this.authService.user.admin) {
			throw new Error('User must be admin for this');
		}

		this.apiService.updateResource(this.user, { enabled: enabled }).then((user: User) => {
			this.user.enabled = enabled;
			this.ionic.toast( enabled ? 'ADMIN.USER_UNBLOCKED_TOAST' : 'ADMIN.USER_BLOCKED_TOAST');
		}).catch((err) => {
    	console.error(err);    	
      this.ionic.alert('GLOBAL.GENERAL_ERROR');
		});

	}
}



// WEBPACK FOOTER //
// ./src/partials/user/profile-form/profile-form.ts